import React, { useEffect, useState } from 'react';
import './App.css';
import Layout from './learning/Layout';


import Template from './components/layouts/Template';
import Login from './components/auth/Login';

import { getToken, onMessage } from "firebase/messaging";
import { messaging, myFirestore } from "./config/MyFirebase";


import { toast, ToastContainer } from "react-toastify";
import Message from "./components/Message";
import MyNotification from "./components/MyNotification";
import "react-toastify/dist/ReactToastify.css";
import { getAuth, signInWithCustomToken, signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useAppDispatch, useAppSelector } from './config/hooks';
import { useNavigate } from 'react-router-dom';
import { setUser } from './config/userSlice';

function App() {

  const user = useAppSelector((state) => state.user.user)
  const dispatch = useAppDispatch()

  const navigate = useNavigate();


  const [numberTryToLogin, setNumberTryToLogin] = useState<number>(0);
  const [errorCode, setErrorCode] = useState();
  const [errorMessage, setErrorMessage] = useState();



  const [fcmToken, setFcmToken] = useState("");

  const ipcRenderer = (window as any).ipcRenderer;

  const auth = getAuth();


  const signInWithToken = (token: any) => {

    signInWithCustomToken(auth, token)
      .then(async (userCredential) => {
        // Signed in 
        toast(<MyNotification image={""} title={"Login success"} body={"Welcome"} />);
        // const user = userCredential.user;
        const userId = userCredential.user.uid;
        console.log(userCredential);


        //Get user data with her id
        const docRef = doc(myFirestore, "users", userId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());

          dispatch(setUser(docSnap.data()));
          navigate('/dashboard');

        } else {
          // docSnap.data() will be undefined in this case
          //JE DOIS METTRE LA LOGIQUE DE DECONNEXION SIGN OUT AVANT DE REDIRIGER VERS LE LOGIN
          console.log("No such document!");
          navigate('/');
          toast(<MyNotification image={""} title={"Login failed"} body={"Try again"} />);

        }

      })
      .catch((error) => {
        toast(<MyNotification image={""} title={"Login failed"} body={"Try again"} />);

        const newErrorCode = error.code;
        const newErrorMessage = error.message;
        setErrorMessage(newErrorMessage);
        setErrorCode(newErrorCode);
        // console.log(errorMessage);
        // console.log(errorCode);
      });
  }

  if (ipcRenderer && ipcRenderer != null) {

    ipcRenderer.on("send-custom-login-token", (value: any) => {
      // var numberTryToLoginPlusOne = numberTryToLogin + 1;
      // console.log("numberTryToLoginPlusOne: ", numberTryToLoginPlusOne);
      // setNumberTryToLogin(1);
      // console.log("number try: ", numberTryToLogin);
      if (auth.currentUser) {
        console.log("already loged")
      } else {

        signInWithToken(value);
      }
      // if (numberTryToLogin && numberTryToLogin < 1) {
      //   console.log("receive cstk login");


      // }
    })
  }




  onMessage(messaging, (payload) => {
    console.log('App.tsx Received foreground message ', payload.data);

    if (payload.data) {

      const token = payload.data['token'];

      if (token) {

        signInWithToken(token);
      }
    }



  });





  async function requestPermissionAndGetToken() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();

    if (permission === "granted") {

      //Try to get token
      getToken(messaging, { vapidKey: 'BEirp6mHwqebZrWFZqJimSXhtxA_zoWCjTLcOrmdGQGEvjAeHHoUOrJgfhqbwT--OI4DQVBLCgOj-a8oxtiyvn8' }).then((currentToken) => {
        if (currentToken) {
          // Send the token to your server and update the UI if necessary
          // ...
          console.log('currentToken: ');
          console.log(currentToken);
          setFcmToken(currentToken);

        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
          // ...
        }
      }).catch((err) => {
        // ...
        const electron = (window as any).electron;
        if (electron) {
          electron.getFCMToken('getFCMToken', (_: any, token: any) => {
            setFcmToken(token);
            console.log('currentToken: ');
            console.log(token);
          });

        } else {
          console.log('An error occurred while retrieving token. ', err);
        }
      });

    } else if (permission === "denied") {
      //notifications are blocked
      alert("You denied for the notification");
    }
  }

  useEffect(() => {

    requestPermissionAndGetToken();
    // electron.getFCMToken('getFCMToken', (_: any, token: any) => {
    //   setFcmToken(token);
    //   console.log('currentToken: ');
    //   console.log(token);
    // });

  }, []);

  return (
    <div className="App">
      {/* <Layout></Layout> */}
      <Login token={fcmToken} />
      <ToastContainer />
    </div>
  );
}

export default App;
